export const isNode = false;

